// extracted by mini-css-extract-plugin
export default {"piechartVillageTalukaContainer":"VillageChart_piechartVillageTalukaContainer__VgWMO","piechartVillageTaluka":"VillageChart_piechartVillageTaluka__HBvCe"};